export default __webpack_public_path__ + "static/media/Animations_Circle5.a2e54d5a.svg";